<template>
  <button class="user-button" @click.capture.stop.prevent="handleClick">
    <AppModalProfileAvatar v-if="isSignedIn" :user="user" />
    <svg v-else class="anonymous" viewBox="0 0 24 24" aria-label="Sign in">
      <circle cx="12" cy="12" r="11" fill="none" stroke="currentColor" stroke-width="1.5" />
      <circle cx="12" cy="9.5" r="3.5" fill="currentColor" />
      <path d="M5.5 19.5c1.3-3 3.8-4.5 6.5-4.5s5.2 1.5 6.5 4.5" fill="currentColor" />
    </svg>
  </button>
</template>

<script setup>
import {useRouter} from "vue-router";
import AppModalProfileAvatar from "@/components/App/Modal/Profile/Avatar";
import useUserSafe from "@/composables/useUserSafe";

const router = useRouter();
const {isSignedIn, user} = useUserSafe();

function handleClick() {
  router.push({hash: isSignedIn.value ? "#profile" : "#sign-in"});
}
</script>

<style scoped>
/* as tall as the sponsor's two lines beside it (Seán, 2026-10-22: 2 × 1.1 line height, 35 px),
   signed out or in, the avatar default or their own */
.user-button {
  height: 2.2rem;
  aspect-ratio: 1;
  border: none;
  border-radius: 50%;
  box-shadow: none; /* undo the global button card: the circle floats on the image */
  padding: 0;
  cursor: pointer;
  background: none;
  color: var(--primary-navigation-color, white);
  display: grid;
  place-items: center;
  transition: opacity 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  opacity: 1;
}
.user-button:hover {
  opacity: 0.65;
}
:deep(.avatar) {
  box-shadow: none;
}
:deep(svg) {
  height: 100%;
  width: auto;
}
</style>
